// Digest: a523fb9cb2e45829052e9b9f60ab7821d108b262
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type _IconGridItemsOrNull = null | _IconGridItems;
export type _IconGridItems = (
  | {
      type: "copy";
      value: CharBlock;
      id: string;
    }
  | {
      type: "icon";
      value: ImageChooserBlock;
      id: string;
    }
)[];
export type TextBlockOrNull = null | TextBlock;
export type TextBlock = string;
export type _ShowcaseCardListOrNull = null | _ShowcaseCardList;
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type _ShowcaseCardList = _ShowcaseCard[];
export type CareersPageBlocks = (
  | {
      type: "hero";
      value: LPHeroBlock;
      id: string;
    }
  | {
      type: "job_list";
      value: JobListBlock;
      id: string;
    }
  | {
      type: "icon_grid";
      value: IconGridBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: FeaturedRichTextBlock;
      id: string;
    }
  | {
      type: "quotes";
      value: QuotesBlock;
      id: string;
    }
  | {
      type: "showcase";
      value: ShowcaseBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: ThelabSpacerBlock;
      id: string;
    }
)[];
export type HeroImageBlock = {
  type: "hero";
  value: MediaChooserBlock;
  id: string;
}[];
export type CaseStudyRoles = {
  type: "role";
  value: CharBlock;
  id: string;
}[];
export type StatItemListOrNull = null | StatItemList;
export type StatItemList = StatItem[];
export type CaseStudyBody = (
  | {
      type: "rich_text";
      value: FeaturedRichTextBlock;
      id: string;
    }
  | {
      type: "showcase";
      value: ShowcaseBlock;
      id: string;
    }
  | {
      type: "split_block";
      value: SplitBlock;
      id: string;
    }
  | {
      type: "quotes";
      value: QuotesBlock;
      id: string;
    }
  | {
      type: "stats";
      value: StatsBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: ThelabSpacerBlock;
      id: string;
    }
  | {
      type: "tabs";
      value: TabbedBlock;
      id: string;
    }
)[];
export type LPStreamBlock = {
  type: "rich_text";
  value: AlignedRichTextSubBlock;
  id: string;
}[];
export type ThemeOverrideSubBlockOrNull = null | ThemeOverrideSubBlock;
export type ThemeOverrideSubBlock = "" | "cream" | "black" | "darkGray" | "midGray" | "lightGray" | "coolGray";
export type ServicesStorySlideBlockOrNull = null | ServicesStorySlideBlock;
export type IntegerBlockOrNull = null | IntegerBlock;
export type IntegerBlock = number;
export type ServicesBodyStreamBlock = (
  | {
      type: "story";
      value: ServicesStoryBlock;
      id: string;
    }
  | {
      type: "locations";
      value: ServicesLocationsBlock;
      id: string;
    }
  | {
      type: "media";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "stats";
      value: StatsBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: ThelabSpacerBlock;
      id: string;
    }
  | {
      type: "hero_image";
      value: HeroImageBlock;
      id: string;
    }
)[];
export type VideoChooserBlockOrNull = null | VideoChooserBlock;
export type LockedDownRichTextOrNull = null | LockedDownRichText;
export type LockedDownRichText = string;
export type LinkSubBlockOrNull = null | LinkSubBlock;
export type BlogPostListItemSubBlockOrNull = null | BlogPostListItemSubBlock;
export type ClientSvgChooser =
  | ""
  | "client-brooklinen"
  | "client-devacurl"
  | "client-douglaselliman"
  | "client-fortunebrands"
  | "client-fritolay"
  | "client-hyundai"
  | "client-kentuckylegend"
  | "client-laaurora"
  | "client-pernodricard"
  | "client-qdoba"
  | "client-sks"
  | "client-supernal"
  | "client-tempurpedic"
  | "client-vistaprint"
  | "client-yamazaki";
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type AnimationBlocks = (
  | {
      type: "hero";
      value: HeroBlock;
      id: string;
    }
  | {
      type: "hero_image";
      value: HeroImageBlock;
      id: string;
    }
  | {
      type: "expand_media";
      value: ExpandMediaBlock;
      id: string;
    }
  | {
      type: "paragraph_slides";
      value: ParagraphSlidesBlock;
      id: string;
    }
  | {
      type: "ticker";
      value: TickerBlock;
      id: string;
    }
  | {
      type: "blog_showcase";
      value: FeaturedCaseStudiesBlock;
      id: string;
    }
  | {
      type: "logo_list";
      value: LogoListBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: AnimatedFeaturedRichTextBlock;
      id: string;
    }
  | {
      type: "showcase";
      value: ShowcaseBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: AnimatedSpacerBlock;
      id: string;
    }
  | {
      type: "media_feed";
      value: MediaFeedBlock;
      id: string;
    }
)[];
export type WorkPageBlocks = (
  | {
      type: "hero";
      value: LPHeroBlock;
      id: string;
    }
  | {
      type: "case_study_grid";
      value: CaseStudyGridBlock;
      id: string;
    }
  | {
      type: "featured_case_studies";
      value: FeaturedCaseStudiesBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: ThelabSpacerBlock;
      id: string;
    }
)[];
export type HeaderNavigationBodyBlock = {
  type: "menu_item";
  value: SimpleLinkBlock;
  id: string;
}[];
export type FooterNavigationBodyBlock = {
  type: "location";
  value: FooterNavigationLocation;
  id: string;
}[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  CareersPageTemplateProps: ServerCmsModelsPagesCareersPageCareersPageTemplate;
  CaseStudyTemplateProps: ServerCmsModelsPagesCaseStudyPageCaseStudyTemplate;
  ContactUsPageTemplateProps: ServerCmsModelsPagesContactUsPageContactUsPageTemplate;
  ContactUsLPTemplateProps: ServerCmsModelsPagesContactUsPageContactUsLPTemplate;
  ServicesPageTemplateProps: ServerCmsModelsPagesServicesPageServicesPageTemplate;
  HomePageTemplateProps: ServerCmsModelsPagesHomePageHomePageTemplate;
  LegalPageTemplateProps: ServerCmsModelsPagesLegalPageLegalPageTemplate;
  WorkPageTemplateProps: ServerCmsModelsPagesWorkPageWorkPageTemplate;
  StorybookTemplateProps: ServerUrlsStorybookTemplate;
  globals: {
    Widget:
      | DjangoFormsWidgetsSelect
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsEmailInput
      | DjangoFormsWidgetsTextarea;
    models: {
      "cms.models.pages.contact_us_page.ContactUsEmbedProps": CmsModelsPagesContactUsPageContactUsEmbedProps;
    };
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsSettingsProcessor &
    ServerCmsContextProcessorsNavigationProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsModelsPagesCareersPageCareersPageTemplate {
  is_preview: boolean;
  page: CareersPage_822Ea5A8Ce;
}
export interface CareersPage_822Ea5A8Ce {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsCareersPage;
}
export interface CmsCareersPage {
  _type: "StreamField";
  _variant: "cms.CareersPage.body";
  value: CareersPageBlocks;
  [k: string]: unknown;
}
export interface LPHeroBlock {
  heading: RichTextBlockOrNull;
  copy: RichTextBlockOrNull;
  time: number;
}
export interface JobListBlock {
  listings: {
    id: number;
    title: {
      id: null;
      label: string;
    };
    postedDate: string;
    location: {
      id: number | null;
      label: string;
      address: {
        name: string | null;
        description: string | null;
        addressLine1: string | null;
        addressLine2: string | null;
        city: string | null;
        state: string | null;
        zipcode: string | null;
        country: string | null;
        phoneNumber: string | null;
      };
    };
    department: {
      id: number;
      label: string;
    };
    status: {
      id: number;
      label: string;
    };
    newApplicantsCount: number;
    activeApplicantsCount: number;
    totalApplicantsCount: number;
    postingUrl: string;
  }[];
}
export interface IconGridBlock {
  items: _IconGridItemsOrNull;
}
export interface FeaturedRichTextBlock {
  layouts: null | ("left" | "center" | "right");
  content: RichTextBlockOrNull;
}
export interface QuotesBlock {
  text_color: null | ("light" | "dark");
  background_color?: CharBlockOrNull;
  background_image?: ImageChooserBlockOrNull;
  quotes:
    | null
    | {
        type: "quote";
        value: _Quote;
        id: string;
      }[];
}
export interface _Quote {
  body: TextBlockOrNull;
  attribution: CharBlockOrNull;
  avatar?: ImageChooserBlockOrNull;
}
export interface ShowcaseBlock {
  layout: null | ("Full" | "Grid");
  images?: _ShowcaseCardListOrNull;
}
export interface _ShowcaseCard {
  media: MediaChooserBlockOrNull;
  rounded?: BooleanBlockOrNull;
  caption?: CharBlockOrNull;
}
export interface ThelabSpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "xsmall" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface ServerCmsModelsPagesCaseStudyPageCaseStudyTemplate {
  is_preview: boolean;
  page: CaseStudyPage_44Bcfd7218;
}
export interface CaseStudyPage_44Bcfd7218 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  color_theme: string;
  client: string;
  hero_text: RichTextField | null;
  hero_image: CmsCaseStudyPage;
  tags: {
    name: string;
  }[];
  intro: string;
  roles: CmsCaseStudyPage1;
  project_link: CmsCaseStudyPage2;
  body: CmsCaseStudyPage3;
  next_case_study: CaseStudyPage_89Ad862Cb9;
}
export interface CmsCaseStudyPage {
  _type: "StreamField";
  _variant: "cms.CaseStudyPage.hero_image";
  value: HeroImageBlock;
  [k: string]: unknown;
}
export interface CmsCaseStudyPage1 {
  _type: "StreamField";
  _variant: "cms.CaseStudyPage.roles";
  value: CaseStudyRoles;
  [k: string]: unknown;
}
export interface CmsCaseStudyPage2 {
  _type: "StreamField";
  _variant: "cms.CaseStudyPage.project_link";
  value: {
    type: "link";
    value: SimpleLinkBlock;
    id: string;
  }[];
  [k: string]: unknown;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface CmsCaseStudyPage3 {
  _type: "StreamField";
  _variant: "cms.CaseStudyPage.body";
  value: CaseStudyBody;
  [k: string]: unknown;
}
export interface SplitBlock {
  layout: null | ("Full" | "Container");
  alignment: null | ("Left" | "Right");
  media: MediaChooserBlockOrNull;
  text: RichTextBlockOrNull;
}
export interface StatsBlock {
  header: RichTextBlockOrNull;
  stats?: StatItemListOrNull;
}
export interface StatItem {
  large_text: CharBlockOrNull;
  small_text?: CharBlockOrNull;
  paragraph: CharBlockOrNull;
  icon?: ImageChooserBlockOrNull;
}
export interface TabbedBlock {
  title: CharBlockOrNull;
  tabs:
    | null
    | {
        type: "media";
        value: MediaTab;
        id: string;
      }[];
}
export interface MediaTab {
  tab_name: CharBlockOrNull;
  media: MediaChooserBlockOrNull;
  caption?: RichTextBlockOrNull;
}
export interface CaseStudyPage_89Ad862Cb9 {
  id: number;
  title: string;
  url: string;
  client: string;
  showcase_title: string;
  showcase_media: CmsCaseStudyPage4;
}
export interface CmsCaseStudyPage4 {
  _type: "StreamField";
  _variant: "cms.CaseStudyPage.showcase_media";
  value: MediaChooserBlock;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesContactUsPageContactUsPageTemplate {
  is_preview: boolean;
  page: CmsModelsPagesContactUsPageContactUsEmbedProps;
  form: ServerCmsForms;
}
export interface CmsModelsPagesContactUsPageContactUsEmbedProps {
  id: number;
  title: string;
  body: CmsContactUsPage;
  lp_body: CmsContactUsPage1;
  url: string;
}
export interface CmsContactUsPage {
  _type: "StreamField";
  _variant: "cms.ContactUsPage.body";
  value: LPStreamBlock;
  [k: string]: unknown;
}
export interface CmsContactUsPage1 {
  _type: "StreamField";
  _variant: "cms.ContactUsPage.lp_body";
  value: LPStreamBlock;
  [k: string]: unknown;
}
export interface ServerCmsForms {
  name: "server.cms.forms.ContactUsForm";
  errors: {
    subject?: string[];
    name?: string[];
    email?: string[];
    business_name?: string[];
    message?: string[];
  } | null;
  fields: {
    subject: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    email: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsEmailInput;
    } & {};
    business_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    message: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
  };
  prefix: string;
  iterator: ("subject" | "name" | "email" | "business_name" | "message")[];
  hidden_fields?: ("subject" | "name" | "email" | "business_name" | "message")[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedSerializationWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsEmailInput {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface ServerCmsModelsPagesContactUsPageContactUsLPTemplate {
  is_preview: boolean;
  page: CmsModelsPagesContactUsPageContactUsEmbedProps;
}
export interface ServerCmsModelsPagesServicesPageServicesPageTemplate {
  is_preview: boolean;
  page: ServicesPageCf8F482C1B;
}
export interface ServicesPageCf8F482C1B {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  color_theme: string;
  body: CmsServicesPage;
}
export interface CmsServicesPage {
  _type: "StreamField";
  _variant: "cms.ServicesPage.body";
  value: ServicesBodyStreamBlock;
  [k: string]: unknown;
}
export interface ServicesStoryBlock {
  color_theme?: ThemeOverrideSubBlockOrNull;
  hero: RichTextBlockOrNull;
  insights?: ServicesStorySlideBlockOrNull;
  creative?: ServicesStorySlideBlockOrNull;
  technology?: ServicesStorySlideBlockOrNull;
  body: RichTextBlockOrNull;
  media_slider:
    | null
    | {
        type: "media";
        value: MediaChooserBlock;
        id: string;
      }[];
}
export interface ServicesStorySlideBlock {
  label: CharBlockOrNull;
  body: RichTextBlockOrNull;
}
export interface ServicesLocationsBlock {
  color_theme?: ThemeOverrideSubBlockOrNull;
  body_left: RichTextBlockOrNull;
  body_right: RichTextBlockOrNull;
  locations:
    | null
    | {
        type: "location";
        value: LocationBlock;
        id: string;
      }[];
}
export interface LocationBlock {
  title: CharBlockOrNull;
  timezone: IntegerBlockOrNull;
  hiring: boolean;
}
export interface ServerCmsModelsPagesHomePageHomePageTemplate {
  is_preview: boolean;
  page: HomePage_4Eb9067435;
}
export interface HomePage_4Eb9067435 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsHomePage;
  contact_form: ServerCmsForms1;
  color_theme: string;
}
export interface CmsHomePage {
  _type: "StreamField";
  _variant: "cms.HomePage.body";
  value: AnimationBlocks;
  [k: string]: unknown;
}
export interface HeroBlock {
  subtitle: RichTextBlockOrNull;
  time: number;
}
export interface ExpandMediaBlock {
  poster_media?: MediaChooserBlockOrNull;
  media?: VideoChooserBlockOrNull;
}
export interface ParagraphSlidesBlock {
  slides:
    | null
    | {
        type: "slide";
        value: ParagraphSlide;
        id: string;
      }[];
  cta?: LinkSubBlockOrNull;
  time: number;
}
export interface ParagraphSlide {
  icon: null | ("" | "circle" | "hills" | "eye");
  text: LockedDownRichTextOrNull;
}
export interface TickerBlock {
  text: RichTextBlockOrNull;
  time: number;
}
export interface FeaturedCaseStudiesBlock {
  lines:
    | null
    | (
        | {
            type: "Single";
            value: SingleCaseStudyShowcase;
            id: string;
          }
        | {
            type: "Double";
            value: DoubleCaseStudyShowcase;
            id: string;
          }
      )[];
  cta?: LinkSubBlockOrNull;
  time: number;
}
export interface SingleCaseStudyShowcase {
  post: BlogPostListItemSubBlockOrNull;
}
export interface BlogPostListItemSubBlock {
  id: number;
  url: string;
  title: string;
  media: MediaChooserBlock;
  client: string;
  tags: {
    name: string;
    slug: string;
    id: number;
  }[];
}
export interface DoubleCaseStudyShowcase {
  primary: null | ("left" | "right" | "equal");
  left: BlogPostListItemSubBlockOrNull;
  right: BlogPostListItemSubBlockOrNull;
}
export interface LogoListBlock {
  logos:
    | null
    | {
        type: "logo";
        value: ClientSvgChooser;
        id: string;
      }[];
  time: number;
}
export interface AnimatedFeaturedRichTextBlock {
  layouts: null | ("left" | "center" | "right");
  content: RichTextBlockOrNull;
  time: number;
}
export interface AnimatedSpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "xsmall" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
  time: number;
}
export interface MediaFeedBlock {
  color_theme?: ThemeOverrideSubBlockOrNull;
  title: RichTextBlockOrNull;
  slides:
    | null
    | {
        type: "slide";
        value: ExternalMediaSlide;
        id: string;
      }[];
  cta_text: LockedDownRichTextOrNull;
  cta_link?: SimpleLinkBlockOrNull;
  time: number;
}
export interface ExternalMediaSlide {
  image: ImageChooserBlockOrNull;
  alt_text: CharBlockOrNull;
  url: URLBlockOrNull;
  is_video?: BooleanBlockOrNull;
}
export interface ServerCmsForms1 {
  name: "server.cms.forms.ContactUsForm";
  errors: {
    subject?: string[];
    name?: string[];
    email?: string[];
    business_name?: string[];
    message?: string[];
  } | null;
  fields: {
    subject: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    email: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsEmailInput;
    } & {};
    business_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    message: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
  };
  prefix: string;
  iterator: ("subject" | "name" | "email" | "business_name" | "message")[];
  hidden_fields?: ("subject" | "name" | "email" | "business_name" | "message")[];
}
export interface ServerCmsModelsPagesLegalPageLegalPageTemplate {
  is_preview: boolean;
  page: LegalPageCfe7296B10;
}
export interface LegalPageCfe7296B10 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: RichTextField;
}
export interface ServerCmsModelsPagesWorkPageWorkPageTemplate {
  is_preview: boolean;
  page: WorkPage_714C89C984;
}
export interface WorkPage_714C89C984 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsWorkPage;
}
export interface CmsWorkPage {
  _type: "StreamField";
  _variant: "cms.WorkPage.body";
  value: WorkPageBlocks;
  [k: string]: unknown;
}
export interface CaseStudyGridBlock {
  studies:
    | null
    | {
        type: "case_study";
        value: _CaseStudy;
        id: string;
      }[];
}
export interface _CaseStudy {
  media: MediaChooserBlockOrNull;
  heading: CharBlockOrNull;
  client: CharBlockOrNull;
  work_types:
    | null
    | {
        type: "type";
        value: "marketing" | "website" | "content";
        id: string;
      }[];
}
export interface ServerUrlsStorybookTemplate {}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  key: string;
  value: string;
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  apple_touch_icon: string;
  favicon_png_lg: string;
  favicon_png_sm: string;
  mask_icon: string;
  favicon_ico: string;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  SENTRY_DSN: string | null;
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  header_nav: HeaderNavigationSettings_41Bc9Da531 | null;
  footer_nav: FooterNavigationSettings_2441Cdc5E1 | null;
  contact_form_page: CmsModelsPagesContactUsPageContactUsEmbedProps | null;
  contact_form: ServerCmsForms | null;
}
export interface HeaderNavigationSettings_41Bc9Da531 {
  body: CmsHeaderNavigationSettings;
}
export interface CmsHeaderNavigationSettings {
  _type: "StreamField";
  _variant: "cms.HeaderNavigationSettings.body";
  value: HeaderNavigationBodyBlock;
  [k: string]: unknown;
}
export interface FooterNavigationSettings_2441Cdc5E1 {
  body: CmsFooterNavigationSettings;
}
export interface CmsFooterNavigationSettings {
  _type: "StreamField";
  _variant: "cms.FooterNavigationSettings.body";
  value: FooterNavigationBodyBlock;
  [k: string]: unknown;
}
export interface FooterNavigationLocation {
  title: CharBlockOrNull;
  address1: CharBlockOrNull;
  address2: CharBlockOrNull;
  phone: CharBlockOrNull;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as CareersPageTemplateImplementation} from "@client/templates/CareersPageTemplate"
export type CareersPageTemplateCheck = Checker<_Types["CareersPageTemplateProps"], typeof CareersPageTemplateImplementation>;

export namespace templates {
    export type CareersPageTemplate = _Types["CareersPageTemplateProps"];
}


        



import {Template as CaseStudyTemplateImplementation} from "@client/templates/CaseStudyTemplate"
export type CaseStudyTemplateCheck = Checker<_Types["CaseStudyTemplateProps"], typeof CaseStudyTemplateImplementation>;

export namespace templates {
    export type CaseStudyTemplate = _Types["CaseStudyTemplateProps"];
}


        



import {Template as ContactUsPageTemplateImplementation} from "@client/templates/ContactUsPageTemplate"
export type ContactUsPageTemplateCheck = Checker<_Types["ContactUsPageTemplateProps"], typeof ContactUsPageTemplateImplementation>;

export namespace templates {
    export type ContactUsPageTemplate = _Types["ContactUsPageTemplateProps"];
}


        



import {Template as ContactUsLPTemplateImplementation} from "@client/templates/ContactUsLPTemplate"
export type ContactUsLPTemplateCheck = Checker<_Types["ContactUsLPTemplateProps"], typeof ContactUsLPTemplateImplementation>;

export namespace templates {
    export type ContactUsLPTemplate = _Types["ContactUsLPTemplateProps"];
}


        



import {Template as ServicesPageTemplateImplementation} from "@client/templates/ServicesPageTemplate"
export type ServicesPageTemplateCheck = Checker<_Types["ServicesPageTemplateProps"], typeof ServicesPageTemplateImplementation>;

export namespace templates {
    export type ServicesPageTemplate = _Types["ServicesPageTemplateProps"];
}


        



import {Template as HomePageTemplateImplementation} from "@client/templates/HomePageTemplate"
export type HomePageTemplateCheck = Checker<_Types["HomePageTemplateProps"], typeof HomePageTemplateImplementation>;

export namespace templates {
    export type HomePageTemplate = _Types["HomePageTemplateProps"];
}


        



import {Template as LegalPageTemplateImplementation} from "@client/templates/LegalPageTemplate"
export type LegalPageTemplateCheck = Checker<_Types["LegalPageTemplateProps"], typeof LegalPageTemplateImplementation>;

export namespace templates {
    export type LegalPageTemplate = _Types["LegalPageTemplateProps"];
}


        



import {Template as WorkPageTemplateImplementation} from "@client/templates/WorkPageTemplate"
export type WorkPageTemplateCheck = Checker<_Types["WorkPageTemplateProps"], typeof WorkPageTemplateImplementation>;

export namespace templates {
    export type WorkPageTemplate = _Types["WorkPageTemplateProps"];
}


        



import {Template as StorybookTemplateImplementation} from "@client/templates/StorybookTemplate"
export type StorybookTemplateCheck = Checker<_Types["StorybookTemplateProps"], typeof StorybookTemplateImplementation>;

export namespace templates {
    export type StorybookTemplate = _Types["StorybookTemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

